/**
 * Runtime configuration for KaaS deployments.
 *
 * In KaaS: values are injected into window.runtimeConfig by docker-entrypoint.sh
 * reading runtime.conf.js.tmpl at container startup.
 *
 * In legacy S3 / local dev: falls back to REACT_APP_* environment variables
 * baked at build time via env-cmd.
 *
 * Feature-flag vars are NOT here — they stay as process.env only.
 */

declare global {
  interface Window {
    runtimeConfig?: Record<string, string>
  }
}

const rc: Record<string, string> =
  (typeof window !== 'undefined' && window.runtimeConfig) || {}

const get = (rcKey: string, envKey: string, fallback = ''): string =>
  rc[rcKey] || process.env[envKey] || fallback

const config = {
  umbeBaseUrl: get('umbeBaseUrl', 'REACT_APP_UMBE_BASE_URL'),
  oidcDomain: get('oidcDomain', 'REACT_APP_OIDC_DOMAIN'),
  oidcClientId: get('oidcClientId', 'REACT_APP_OIDC_CLIENT_ID'),
  oidcMgmtApiIdentifier: get(
    'oidcMgmtApiIdentifier',
    'REACT_APP_OIDC_MGMT_API_IDENTIFIER'
  ),
  oidcTenant: get('oidcTenant', 'REACT_APP_OIDC_TENANT'),
  oidcRedirectPath: get(
    'oidcRedirectPath',
    'REACT_APP_OIDC_REDIRECT_PATH',
    '/login'
  ),
  loginUrl: get('loginUrl', 'REACT_APP_LOGIN_URL', '/login'),
} as const

export default config
